$(function () {
    $.datepicker._updateDatepicker_original = $.datepicker._updateDatepicker;
    $.datepicker._updateDatepicker = function (inst) {
        $.datepicker._updateDatepicker_original(inst);
        var afterShow = this._get(inst, "afterShow");
        if (afterShow) {
            afterShow.apply(inst.input ? inst.input[0] : null);
        }
    };
    
    if ($(".js-datepicker-ym").length) {
        $(".js-datepicker-ym").datepicker({
            // minDate: new Date(),
            // maxDate: "+10y",
            yearRange: "c-10:c+10",
            changeMonth: true,
            changeYear: true,
            afterShow: function () {
                $.fn.select2.amd.require([
                    "select2/utils",
                    "select2/dropdown",
                    "select2/dropdown/attachContainer",
                    "select2/dropdown/search",
                    "select2/dropdown/attachBody"
                ], function (Utils, Dropdown, DropdownSearch, AttachBody, DropdownAdapter, AttachContainer) {
                    let $select = $('.ui-datepicker-title select').select2({
                        closeOnSelect: false,
                        width: '100%',
                        dropdownAdapter: Utils.Decorate(Utils.Decorate(Dropdown, DropdownSearch), AttachBody)
                    });
                });
            },
            dateFormat: "mm/dd/y",
            altFormat: "yy-mm-dd",
            defaultDate: +1,
            onSelect: function () {
                $(this)
                    .removeClass("error")
                    .closest(".form-item-wrap")
                    .siblings(".js-form-item-sign")
                    .removeClass("c-alert active");
                $(document).trigger("datepickerSelected");

                const date = moment($(this).val(), "MM/DD/YY");
                const formattedDate = date.format("MMM D, YYYY");

                $(this).val(formattedDate);
            },
        });
    }
});

$(document).on("focus", ".js-datepicker", function () {
    let datepicker = $(".ui-datepicker");
    let arr = [];
    datepicker.each(function () {
      arr.push($(this));
    });
    $(this).closest(".js-datepicker-container").append(arr);
    $(document).trigger("datepickerWasMoved");
});

